<template>
  <div class="buyer-page">
    <PageBanner
      title="Property Purchase Guides"
      subtitle="Whether you're looking for a home or a high-yield investment, we've got you covered."
      :bannerImage="'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1600'"
    />

    <BuyerGuidelines />

    <InvestorGuide />
  </div>
</template>

<script setup>
import PageBanner from '@/components/PageBanner.vue';
import BuyerGuidelines from '@/components/BuyerGuidelines.vue';
import InvestorGuide from '@/components/InvestorGuide.vue';
</script>
